module.exports = __webpack_public_path__ + "img/esports.8c5ca513.svg";